// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Drives.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import type { CallContext, CallOptions } from "nice-grpc-common";
import {
  CreateFolderRequest,
  CreateFolderResponse,
  CreateRepositoryRequest,
  CreateRepositoryResponse,
  DeleteFileRequest,
  DeleteFileResponse,
  DeleteFolderRequest,
  DeleteFolderResponse,
  DeleteRepositoryRequest,
  DeleteRepositoryResponse,
  DownloadRequest,
  EmptyTrashRequest,
  EmptyTrashResponse,
  FileChunk,
  FileSearchRequest,
  FileSearchResponse,
  GetAccountDriveSettingsRequest,
  GetAccountDriveSettingsResponse,
  GetFilePreviewRequest,
  GetFilePreviewResponse,
  GrantRepositoryAccessRequest,
  GrantRepositoryAccessResponse,
  ListFilesRequest,
  ListFilesResponse,
  ListRepositoriesRequest,
  ListRepositoriesResponse,
  ListTrashRequest,
  ListTrashResponse,
  MoveFileRequest,
  MoveFileResponse,
  RestoreFromTrashRequest,
  RestoreFromTrashResponse,
  RevokeRepositoryAccessRequest,
  RevokeRepositoryAccessResponse,
  SetAccountDriveSettingsRequest,
  SetAccountDriveSettingsResponse,
  StorageLimits,
  UploadResponse,
  VectorSearchRequest,
  VectorSearchResponse,
} from "./Models/DriveModels";

export const protobufPackage = "daisi.protos.v1";

export interface GetStorageLimitsRequest {
}

export interface SetStorageLimitsRequest {
  AccountId: string;
  Limits?: StorageLimits | undefined;
}

export interface SetStorageLimitsResponse {
  Success: boolean;
}

function createBaseGetStorageLimitsRequest(): GetStorageLimitsRequest {
  return {};
}

export const GetStorageLimitsRequest: MessageFns<GetStorageLimitsRequest> = {
  encode(_: GetStorageLimitsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetStorageLimitsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetStorageLimitsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetStorageLimitsRequest {
    return {};
  },

  toJSON(_: GetStorageLimitsRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetStorageLimitsRequest>, I>>(base?: I): GetStorageLimitsRequest {
    return GetStorageLimitsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetStorageLimitsRequest>, I>>(_: I): GetStorageLimitsRequest {
    const message = createBaseGetStorageLimitsRequest();
    return message;
  },
};

function createBaseSetStorageLimitsRequest(): SetStorageLimitsRequest {
  return { AccountId: "", Limits: undefined };
}

export const SetStorageLimitsRequest: MessageFns<SetStorageLimitsRequest> = {
  encode(message: SetStorageLimitsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.AccountId !== "") {
      writer.uint32(10).string(message.AccountId);
    }
    if (message.Limits !== undefined) {
      StorageLimits.encode(message.Limits, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetStorageLimitsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetStorageLimitsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Limits = StorageLimits.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetStorageLimitsRequest {
    return {
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      Limits: isSet(object.Limits) ? StorageLimits.fromJSON(object.Limits) : undefined,
    };
  },

  toJSON(message: SetStorageLimitsRequest): unknown {
    const obj: any = {};
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (message.Limits !== undefined) {
      obj.Limits = StorageLimits.toJSON(message.Limits);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetStorageLimitsRequest>, I>>(base?: I): SetStorageLimitsRequest {
    return SetStorageLimitsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetStorageLimitsRequest>, I>>(object: I): SetStorageLimitsRequest {
    const message = createBaseSetStorageLimitsRequest();
    message.AccountId = object.AccountId ?? "";
    message.Limits = (object.Limits !== undefined && object.Limits !== null)
      ? StorageLimits.fromPartial(object.Limits)
      : undefined;
    return message;
  },
};

function createBaseSetStorageLimitsResponse(): SetStorageLimitsResponse {
  return { Success: false };
}

export const SetStorageLimitsResponse: MessageFns<SetStorageLimitsResponse> = {
  encode(message: SetStorageLimitsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetStorageLimitsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetStorageLimitsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetStorageLimitsResponse {
    return { Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false };
  },

  toJSON(message: SetStorageLimitsResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetStorageLimitsResponse>, I>>(base?: I): SetStorageLimitsResponse {
    return SetStorageLimitsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetStorageLimitsResponse>, I>>(object: I): SetStorageLimitsResponse {
    const message = createBaseSetStorageLimitsResponse();
    message.Success = object.Success ?? false;
    return message;
  },
};

export type DrivesProtoDefinition = typeof DrivesProtoDefinition;
export const DrivesProtoDefinition = {
  name: "DrivesProto",
  fullName: "daisi.protos.v1.DrivesProto",
  methods: {
    upload: {
      name: "Upload",
      requestType: FileChunk,
      requestStream: true,
      responseType: UploadResponse,
      responseStream: false,
      options: {},
    },
    download: {
      name: "Download",
      requestType: DownloadRequest,
      requestStream: false,
      responseType: FileChunk,
      responseStream: true,
      options: {},
    },
    list: {
      name: "List",
      requestType: ListFilesRequest,
      requestStream: false,
      responseType: ListFilesResponse,
      responseStream: false,
      options: {},
    },
    delete: {
      name: "Delete",
      requestType: DeleteFileRequest,
      requestStream: false,
      responseType: DeleteFileResponse,
      responseStream: false,
      options: {},
    },
    searchFiles: {
      name: "SearchFiles",
      requestType: FileSearchRequest,
      requestStream: false,
      responseType: FileSearchResponse,
      responseStream: false,
      options: {},
    },
    vectorSearch: {
      name: "VectorSearch",
      requestType: VectorSearchRequest,
      requestStream: false,
      responseType: VectorSearchResponse,
      responseStream: false,
      options: {},
    },
    getStorageLimits: {
      name: "GetStorageLimits",
      requestType: GetStorageLimitsRequest,
      requestStream: false,
      responseType: StorageLimits,
      responseStream: false,
      options: {},
    },
    setStorageLimits: {
      name: "SetStorageLimits",
      requestType: SetStorageLimitsRequest,
      requestStream: false,
      responseType: SetStorageLimitsResponse,
      responseStream: false,
      options: {},
    },
    /** Repository management */
    createRepository: {
      name: "CreateRepository",
      requestType: CreateRepositoryRequest,
      requestStream: false,
      responseType: CreateRepositoryResponse,
      responseStream: false,
      options: {},
    },
    listRepositories: {
      name: "ListRepositories",
      requestType: ListRepositoriesRequest,
      requestStream: false,
      responseType: ListRepositoriesResponse,
      responseStream: false,
      options: {},
    },
    deleteRepository: {
      name: "DeleteRepository",
      requestType: DeleteRepositoryRequest,
      requestStream: false,
      responseType: DeleteRepositoryResponse,
      responseStream: false,
      options: {},
    },
    grantRepositoryAccess: {
      name: "GrantRepositoryAccess",
      requestType: GrantRepositoryAccessRequest,
      requestStream: false,
      responseType: GrantRepositoryAccessResponse,
      responseStream: false,
      options: {},
    },
    revokeRepositoryAccess: {
      name: "RevokeRepositoryAccess",
      requestType: RevokeRepositoryAccessRequest,
      requestStream: false,
      responseType: RevokeRepositoryAccessResponse,
      responseStream: false,
      options: {},
    },
    /** Folder management */
    createFolder: {
      name: "CreateFolder",
      requestType: CreateFolderRequest,
      requestStream: false,
      responseType: CreateFolderResponse,
      responseStream: false,
      options: {},
    },
    deleteFolder: {
      name: "DeleteFolder",
      requestType: DeleteFolderRequest,
      requestStream: false,
      responseType: DeleteFolderResponse,
      responseStream: false,
      options: {},
    },
    /** File operations */
    moveFile: {
      name: "MoveFile",
      requestType: MoveFileRequest,
      requestStream: false,
      responseType: MoveFileResponse,
      responseStream: false,
      options: {},
    },
    /** Trash operations */
    listTrash: {
      name: "ListTrash",
      requestType: ListTrashRequest,
      requestStream: false,
      responseType: ListTrashResponse,
      responseStream: false,
      options: {},
    },
    restoreFromTrash: {
      name: "RestoreFromTrash",
      requestType: RestoreFromTrashRequest,
      requestStream: false,
      responseType: RestoreFromTrashResponse,
      responseStream: false,
      options: {},
    },
    emptyTrash: {
      name: "EmptyTrash",
      requestType: EmptyTrashRequest,
      requestStream: false,
      responseType: EmptyTrashResponse,
      responseStream: false,
      options: {},
    },
    /** File preview */
    getFilePreview: {
      name: "GetFilePreview",
      requestType: GetFilePreviewRequest,
      requestStream: false,
      responseType: GetFilePreviewResponse,
      responseStream: false,
      options: {},
    },
    /** Account drive settings */
    getAccountDriveSettings: {
      name: "GetAccountDriveSettings",
      requestType: GetAccountDriveSettingsRequest,
      requestStream: false,
      responseType: GetAccountDriveSettingsResponse,
      responseStream: false,
      options: {},
    },
    setAccountDriveSettings: {
      name: "SetAccountDriveSettings",
      requestType: SetAccountDriveSettingsRequest,
      requestStream: false,
      responseType: SetAccountDriveSettingsResponse,
      responseStream: false,
      options: {},
    },
  },
} as const;

export interface DrivesProtoServiceImplementation<CallContextExt = {}> {
  upload(
    request: AsyncIterable<FileChunk>,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<UploadResponse>>;
  download(
    request: DownloadRequest,
    context: CallContext & CallContextExt,
  ): ServerStreamingMethodResult<DeepPartial<FileChunk>>;
  list(request: ListFilesRequest, context: CallContext & CallContextExt): Promise<DeepPartial<ListFilesResponse>>;
  delete(request: DeleteFileRequest, context: CallContext & CallContextExt): Promise<DeepPartial<DeleteFileResponse>>;
  searchFiles(
    request: FileSearchRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<FileSearchResponse>>;
  vectorSearch(
    request: VectorSearchRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<VectorSearchResponse>>;
  getStorageLimits(
    request: GetStorageLimitsRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<StorageLimits>>;
  setStorageLimits(
    request: SetStorageLimitsRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<SetStorageLimitsResponse>>;
  /** Repository management */
  createRepository(
    request: CreateRepositoryRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<CreateRepositoryResponse>>;
  listRepositories(
    request: ListRepositoriesRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<ListRepositoriesResponse>>;
  deleteRepository(
    request: DeleteRepositoryRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<DeleteRepositoryResponse>>;
  grantRepositoryAccess(
    request: GrantRepositoryAccessRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GrantRepositoryAccessResponse>>;
  revokeRepositoryAccess(
    request: RevokeRepositoryAccessRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<RevokeRepositoryAccessResponse>>;
  /** Folder management */
  createFolder(
    request: CreateFolderRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<CreateFolderResponse>>;
  deleteFolder(
    request: DeleteFolderRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<DeleteFolderResponse>>;
  /** File operations */
  moveFile(request: MoveFileRequest, context: CallContext & CallContextExt): Promise<DeepPartial<MoveFileResponse>>;
  /** Trash operations */
  listTrash(request: ListTrashRequest, context: CallContext & CallContextExt): Promise<DeepPartial<ListTrashResponse>>;
  restoreFromTrash(
    request: RestoreFromTrashRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<RestoreFromTrashResponse>>;
  emptyTrash(
    request: EmptyTrashRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<EmptyTrashResponse>>;
  /** File preview */
  getFilePreview(
    request: GetFilePreviewRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetFilePreviewResponse>>;
  /** Account drive settings */
  getAccountDriveSettings(
    request: GetAccountDriveSettingsRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetAccountDriveSettingsResponse>>;
  setAccountDriveSettings(
    request: SetAccountDriveSettingsRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<SetAccountDriveSettingsResponse>>;
}

export interface DrivesProtoClient<CallOptionsExt = {}> {
  upload(
    request: AsyncIterable<DeepPartial<FileChunk>>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<UploadResponse>;
  download(request: DeepPartial<DownloadRequest>, options?: CallOptions & CallOptionsExt): AsyncIterable<FileChunk>;
  list(request: DeepPartial<ListFilesRequest>, options?: CallOptions & CallOptionsExt): Promise<ListFilesResponse>;
  delete(request: DeepPartial<DeleteFileRequest>, options?: CallOptions & CallOptionsExt): Promise<DeleteFileResponse>;
  searchFiles(
    request: DeepPartial<FileSearchRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<FileSearchResponse>;
  vectorSearch(
    request: DeepPartial<VectorSearchRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<VectorSearchResponse>;
  getStorageLimits(
    request: DeepPartial<GetStorageLimitsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<StorageLimits>;
  setStorageLimits(
    request: DeepPartial<SetStorageLimitsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<SetStorageLimitsResponse>;
  /** Repository management */
  createRepository(
    request: DeepPartial<CreateRepositoryRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<CreateRepositoryResponse>;
  listRepositories(
    request: DeepPartial<ListRepositoriesRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<ListRepositoriesResponse>;
  deleteRepository(
    request: DeepPartial<DeleteRepositoryRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<DeleteRepositoryResponse>;
  grantRepositoryAccess(
    request: DeepPartial<GrantRepositoryAccessRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GrantRepositoryAccessResponse>;
  revokeRepositoryAccess(
    request: DeepPartial<RevokeRepositoryAccessRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<RevokeRepositoryAccessResponse>;
  /** Folder management */
  createFolder(
    request: DeepPartial<CreateFolderRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<CreateFolderResponse>;
  deleteFolder(
    request: DeepPartial<DeleteFolderRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<DeleteFolderResponse>;
  /** File operations */
  moveFile(request: DeepPartial<MoveFileRequest>, options?: CallOptions & CallOptionsExt): Promise<MoveFileResponse>;
  /** Trash operations */
  listTrash(request: DeepPartial<ListTrashRequest>, options?: CallOptions & CallOptionsExt): Promise<ListTrashResponse>;
  restoreFromTrash(
    request: DeepPartial<RestoreFromTrashRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<RestoreFromTrashResponse>;
  emptyTrash(
    request: DeepPartial<EmptyTrashRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<EmptyTrashResponse>;
  /** File preview */
  getFilePreview(
    request: DeepPartial<GetFilePreviewRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetFilePreviewResponse>;
  /** Account drive settings */
  getAccountDriveSettings(
    request: DeepPartial<GetAccountDriveSettingsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetAccountDriveSettingsResponse>;
  setAccountDriveSettings(
    request: DeepPartial<SetAccountDriveSettingsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<SetAccountDriveSettingsResponse>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export type ServerStreamingMethodResult<Response> = { [Symbol.asyncIterator](): AsyncIterator<Response, void> };

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
